exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".instagram[data-v-4de59ca6]{text-align:center}.instagram h1[data-v-4de59ca6]{margin:0 auto 75px}.images[data-v-4de59ca6]{display:flex;justify-content:space-between;align-items:center}.images img[data-v-4de59ca6]{width:20.5vw;height:20.5vw;object-fit:cover}@media (max-width:767px){.instagram[data-v-4de59ca6]{padding-top:35px;padding-bottom:35px}.instagram h1[data-v-4de59ca6]{margin-bottom:25px;font-size:2em}.images[data-v-4de59ca6]{display:unset}.images img[data-v-4de59ca6]{margin:0 4px 4px;display:inline-block;height:unset;width:46%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4de59ca6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/components/instagram/style.scss
// module id = 971
// module chunks = 0